import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Tooltip, Legend, Cell, ResponsiveContainer } from 'recharts';

const PaiChartGraphReview = ({ reviews }) => {
  const [pieChartData, setPieChartData] = useState([]);
  const [allZero, setAllZero] = useState(false);

  useEffect(() => {
    if (reviews && Array.isArray(reviews) && reviews.length > 0) {
      const data = reviews
        .map(item => {
          if (item && typeof item === 'object') {
            const orderCountPercent = parseFloat(item.order_count_percent);
            return !isNaN(orderCountPercent)
              ? { name: item.title || 'Unknown', value: orderCountPercent }
              : null;
          }
          return null;
        })
        .filter(item => item !== null);

      if (data.length > 0) {
        const isAllZero = data.every(d => d.value === 0);
        setAllZero(isAllZero);
        setPieChartData(isAllZero ? [{ name: 'No Data', value: 1 }] : data);
      } else {
        setAllZero(false);
        setPieChartData([{ name: 'No data available', value: 0 }]);
      }
    } else {
      setAllZero(false);
      setPieChartData([{ name: 'No data available', value: 0 }]);
    }
  }, [reviews]);

  const colors = [
    '#2C3E50', '#1ABC9C', '#E74C3C', '#3498DB', '#F39C12',
    '#8E44AD', '#16A085', '#F4A261', '#2ECC71', '#95A5A6',
  ];

  // ✅ Custom label with %
  const renderLabel = ({ name, value }) => `${value}%`;

  // ✅ Custom tooltip showing % value
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { name, value } = payload[0];
      return (
        <div
          style={{
            backgroundColor: 'white',
            border: '1px solid #ccc',
            padding: '8px 12px',
            borderRadius: '6px',
          }}
        >
          <p style={{ margin: 0, fontWeight: 600 }}>{name}</p>
          <p style={{ margin: 0 }}>{`${value}%`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div>
      <div id="pie-chart" className='pie-chart-sec'>
        {pieChartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={350}>
            <PieChart>
              <Pie
                data={pieChartData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                innerRadius={100}
                outerRadius={150}
                label={!allZero ? renderLabel : false}
              >
                {pieChartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={allZero ? 'maroon' : colors[index % colors.length]}
                  />
                ))}
              </Pie>
              {!allZero && <Tooltip content={<CustomTooltip />} />}
              {!allZero && <Legend />}
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div>Loading chart...</div>
        )}
      </div>
    </div>
  );
};

export default PaiChartGraphReview;
